/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AnalyticsCampaignAnalyticsPathParams,
	AnalyticsCampaignAnalyticsResponse,
} from '../types/AnalyticsCampaignAnalytics'

/**
 * GET /campaigns/:campaign/analytics
 * @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::campaignAnalytics
 */
export async function analyticsCampaignAnalytics(
	campaign: AnalyticsCampaignAnalyticsPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AnalyticsCampaignAnalyticsResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/analytics`, config)
}
